// extracted by mini-css-extract-plugin
export default {"label":"MUIMultiItemBox_label__mqLlL"};